import React, { useState } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import { useSessionContext } from 'session'
import { getMemberGalleyUrl } from 'services/member/galleyService'

interface GalleyDialogProps {
  open: boolean
  onClose: () => void
  memberId: number
}

const GALLEY_OPTIONS = [
  { value: 'summary', label: 'Summary Galley' },
  { value: 'details', label: 'Details Galley' }
]

export const GalleyDialog: React.FC<GalleyDialogProps> = ({ open, onClose, memberId }) => {
  const [galleyType, setGalleyType] = useState('summary')
  const { openNewTab } = useSessionContext()

  const handleGenerate = (): void => {
    const url = getMemberGalleyUrl(memberId, galleyType)
    openNewTab(url)
    onClose()
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Generate Proofing Galley</DialogTitle>
      <DialogContent>
        <FormControl component="fieldset">
          <RadioGroup
            value={galleyType}
            onChange={(e) => { setGalleyType(e.target.value) }}
          >
            {GALLEY_OPTIONS.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<Radio />}
                label={option.label}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleGenerate}>
          Generate
        </Button>
      </DialogActions>
    </Dialog>
  )
}
